import React, {ReactElement} from 'react'

import Components, {getComponentName} from '../utils/components'
import {LayoutSection} from '../lib/contentful/types'

interface SectionRendererProps {
  section: LayoutSection
}

const SectionRenderer = ({section}: SectionRendererProps): ReactElement => {
  if (section.hidden) {
    return null
  }

  const Component = Components[getComponentName(section)]

  if (!Component) {
    return null
  }

  return <Component key={section.id} {...section.values} />
}

export default SectionRenderer
